import { createEvent } from '@interhyp/platform-eventbus';
/**
 * Wrapper function for tracking events with a fixed namespace
 * @param type
 */
export function createTrackingEvent(type) {
    const event = createEvent('TRACKING', type);
    return {
        type,
        track: (trackObject) => {
            event.emit(trackObject);
        },
        useTrack: event.useEvent,
        onTrack: (listenerCallback) => {
            const eventListener = (event) => {
                listenerCallback({
                    type: event.type,
                    payload: event.payload,
                });
            };
            event.on(eventListener);
            return () => {
                event.off(eventListener);
            };
        },
    };
}
